
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions/history",
      function () {
        return require("private-next-pages/transactions/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions/history"])
      });
    }
  